import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ProcoreService {

	constructor(
		private http: HttpClient
	) { }

	downloadGeneratedFile(fileContext: any, view: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('isSandbox', isSandbox);
		params = params.set('view', view);
		params = params.set('esignType', 'adobe');
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/generated-file`;

		return this.http.post(requestUrl, JSON.stringify(fileContext), { headers, params, responseType: 'text' });
	}

	getAttachments(companyId: string, projectId: string, fileId: string, view: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('fileId', fileId);
		params = params.set('view', view);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/attachments`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	getProjectFolders(companyId: number, projectId: number, isSandbox: boolean, username: string, procoreUserId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('isSandbox', isSandbox);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);

		const requestUrl = `${environment.serviceUrl}/procore/project-folders`;

		return this.http.get<any>(requestUrl, { params });
	}

	// getRfi(companyId: number, projectId: number, rfiId: string, isSandbox: boolean) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('rfiId', rfiId);
	// 	params = params.set('isSandbox', isSandbox);

	// 	const requestUrl = `${environment.serviceUrl}/procore/rfi`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	// getSignatureRequest(companyId: number, signatureRequestId: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/procore/signature-request`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }



	// getSubmittal(companyId: number, projectId: number, submittalId: string, isSandbox: boolean) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('submittalId', submittalId);
	// 	params = params.set('isSandbox', isSandbox);

	// 	const requestUrl = `${environment.serviceUrl}/procore/submittal`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }

	getUserInfo(companyId: number, authCode: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('authCode', authCode);
		params = params.set('isSandbox', isSandbox);
		params = params.set('esignType', 'adobe');

		const requestUrl = `${environment.serviceUrl}/procore/user-info`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getUsers(companyId: string, projectId: number, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/users`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	// getAccountType(companyId: number) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);

	// 	const requestUrl = `${environment.serviceUrl}/account-type`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }



	// getReminders(companyId: number, signatureRequestId: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);

	// 	const requestUrl = `${environment.serviceUrl}/reminders`;

	// 	return this.http.get<any[]>(requestUrl, { headers, params });
	// }

	// sendReminder(companyId: number, signatureRequestId: string, signerEmail: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);
	// 	params = params.set('signerEmail', signerEmail);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/send-reminder`;

	// 	return this.http.post<any>(requestUrl, '', { headers, params });
	// }

	// getTemplates(companyId: number, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/templates`;

	// 	return this.http.get<any[]>(requestUrl, { headers, params });
	// }



	// getSignatureRequestSignUrl(companyId: number, signatureRequestId: string, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('signatureRequestId', signatureRequestId);
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/signature-request/sign-url`;

	// 	return this.http.get<any>(requestUrl, { headers, params });
	// }










	// createDropboxSignAuth(code: string, state: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('code', code);
	// 	params = params.set('state', state);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-auth`;

	// 	return this.http.post(requestUrl, '', { headers, params, responseType: 'text' });
	// }

	// getDropboxSignUserExists(username: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('username', username);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-user-exists`;

	// 	return this.http.get<boolean>(requestUrl, { headers, params });
	// }

	// getDropboxSignAuthUrl(username: string, companyId: number) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('username', username);
	// 	params = params.set('companyId', companyId);

	// 	const requestUrl = `${environment.serviceUrl}/dropboxsign-auth-url`;

	// 	return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	// }

	// cancel(requestBody: any, isSandbox: boolean) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);

	// 	const requestUrl = `${environment.serviceUrl}/cancel`;

	// 	return this.http.post(requestUrl, requestBody, { headers, params });
	// }

	// createEmbeddedUnclaimedDraft(file: File, signatureInfo: any, isSandbox: boolean) {
	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);

	// 	const formData = new FormData();
	// 	if (file) {
	// 		formData.append('file', file, file.name);
	// 	}
	// 	formData.append('body', JSON.stringify(signatureInfo));

	// 	const requestUrl = `${environment.serviceUrl}/createEmbeddedUnclaimedDraft`;

	// 	return this.http.post(requestUrl, formData, { params, responseType: 'text' });
	// }

	// createEmbeddedSignatureRequest(file: File, signatureInfo: any, isSandbox: boolean) {
	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);

	// 	const formData = new FormData();
	// 	if (file) {
	// 		formData.append('file', file, file.name);
	// 	}
	// 	formData.append('body', JSON.stringify(signatureInfo));

	// 	const requestUrl = `${environment.serviceUrl}/createEmbeddedSignatureRequest`;

	// 	return this.http.post(requestUrl, formData, { params });
	// }



	// getFile(signatureInfo: any, isSandbox: boolean, view: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('view', view);

	// 	const requestUrl = `${environment.serviceUrl}/file`;

	// 	return this.http.post(requestUrl, JSON.stringify(signatureInfo), { headers, params, responseType: 'text' });
	// }

	// getSignatureRequestFile(signatureInfo: any, userEmail: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('userEmail', userEmail);

	// 	const requestUrl = `${environment.serviceUrl}/signature-request/download`;

	// 	return this.http.post(requestUrl, JSON.stringify(signatureInfo), { headers, params, responseType: 'blob' });
	// }

	// domainLookup(domain: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('domain', domain);

	// 	return this.http.get<boolean>(`${environment.serviceUrl}/domain-lookup`, { params });
	// }

	// contactLookup(companyId: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);

	// 	return this.http.get<any[]>(`${environment.serviceUrl}/contact-lookup`, { params });
	// }

	// getPackages() {
	// 	const params = new HttpParams();

	// 	return this.http.get<boolean>(`${environment.serviceUrl}/packages`, { params });
	// }

	// updateClient(client: Client) {
	// 	const params = new HttpParams();
	// 	const requestUrl = `${environment.serviceUrl}/client`;

	// 	return this.http.put<Client>(requestUrl, client, { params });
	// }

	// createClient(client: Client, createInHubspot: boolean) {
	// 	let params = new HttpParams();
	// 	params = params.set('createInHubspot', createInHubspot);

	// 	const requestUrl = `${environment.serviceUrl}/client`;

	// 	return this.http.post<Client>(requestUrl, client, { params });
	// }

	// createHubspotEntry(client: Client) {
	// 	const params = new HttpParams();
	// 	const requestUrl = `${environment.serviceUrl}/hubspot-entry`;

	// 	return this.http.post<Client>(requestUrl, client, { params });
	// }

	// createInvoice(clientId: string, invoiceInfo: any) {
	// 	return this.http.post<boolean>(`${environment.serviceUrl}/client/${clientId}/invoice`, invoiceInfo, { observe: 'response' });
	// }

	// notifySignup(clientId: number, technicalContactName: string, billingContactName: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('clientId', clientId);
	// 	params = params.set('technicalContactName', technicalContactName);
	// 	params = params.set('billingContactName', billingContactName);

	// 	return this.http.post(`${environment.serviceUrl}/notifySignup`, '', { params });
	// }

	// getProcoreEntryByClient(clientId: number) {
	// 	let params = new HttpParams();
	// 	params = params.set('clientId', clientId);

	// 	return this.http.get<boolean>(`${environment.serviceUrl}/procore-by-client`, { params });
	// }

	// getProcoreEntryByCompany(companyId: number, projectId: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);

	// 	return this.http.get<any>(`${environment.serviceUrl}/procore-by-company`, { params });
	// }

	// updateProcoreEntry(procoreInfo: any) {
	// 	const params = new HttpParams();
	// 	const requestUrl = `${environment.serviceUrl}/procore-detail`;

	// 	return this.http.put<Client>(requestUrl, procoreInfo, { params });
	// }

	// updateProcoreProjectConfigs(configs: any, clientId: number, projectId: string) {
	// 	let params = new HttpParams();
	// 	params = params.set('clientId', clientId);
	// 	params = params.set('projectId', projectId);

	// 	const requestUrl = `${environment.serviceUrl}/procore-detail/project-configs`;

	// 	return this.http.post<any>(requestUrl, configs, { params });
	// }

	// createProcoreEntry(procoreInfo: any) {
	// 	const params = new HttpParams();
	// 	const requestUrl = `${environment.serviceUrl}/procore-detail`;

	// 	return this.http.post<ClientDetailProcore>(requestUrl, procoreInfo, { params });
	// }

	// checkEmbeddedUrl(companyId: number, url: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('url', url);

	// 	const requestUrl = `${environment.serviceUrl}/check-embedded-url`;

	// 	return this.http.get<boolean>(requestUrl, { headers, params });
	// }


}
